export default [
  {
    path: '/x/pad-version',
    name: 'pad-version',
    component: () => import('@/views/pad-version.vue'),
    meta: {
      keepAlive: false
    }
  },
]